import { render } from "./KeyValueTable.vue?vue&type=template&id=d5bcbb42"
import script from "./KeyValueTable.vue?vue&type=script&lang=js"
export * from "./KeyValueTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/tobias/Desktop/screenads/nova-custom2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"KeyValueTable.vue"]])

export default __exports__